import React, { useEffect, useState, Suspense, lazy  } from "react";
import { Routes, Route, NavLink, Navigate, useLocation  } from "react-router-dom";

// import Ambassadorclub from "./pages/AmbassadorClub";
import Home from "./pages/Home";
// import Events from "./pages/Events";
//import EventRegistration from "./pages/EventRegistration";
//import SlamFestInfo from "./pages/SlamFestInfo";
// import EventsWithSchools from "./pages/eventswithschools";
//import AmbassadorClubRegister from "./pages/AmbassadorClubRegister";
//import CookiesPolicy from "./pages/CookiesPolicy";
//import PrivacyPolicy from "./pages/PrivacyPolicy";
//import RefundPolicy from "./pages/RefundPolicy";
//import TermsConditions from "./pages/TermsConditions";
import Footer from "./components/Footer";
import "./App.css";

const Ambassadorclub = lazy(() => import("./pages/AmbassadorClub"));
const Screening = lazy(() => import("./pages/Screening"));
const EventDetails = lazy(() => import("./pages/EventDetails"));
const Events = lazy(() => import("./pages/Events"));
const EventRegistration = lazy(() => import("./pages/EventRegistration"));
const SlamFestInfo = lazy(() => import("./pages/SlamFestInfo"));
const EventsWithSchools = lazy(() => import("./pages/eventswithschools"));
const AmbassadorClubRegister = lazy(() => import("./pages/AmbassadorClubRegister"));
const CookiesPolicy = lazy(() => import("./pages/CookiesPolicy"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const RefundPolicy = lazy(() => import("./pages/RefundPolicy"));
const TermsConditions = lazy(() => import("./pages/TermsConditions"));
const BookingSuccess = lazy(() => import("./pages/BookingSuccess"));
const SeeTheGlimpse = lazy(() => import("./pages/SeeTheGlimpse.js"));
//const AllEvents = lazy(() => import("./pages/AllEvents.js"));

export default function App() {
  const [scrolled, setScrolled] = useState(false);
const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

useEffect(() => {
  const params = new URLSearchParams(location.search);

  const utmKeys = [
    "utm_source",
    "utm_medium",
    "utm_campaign"
  ];

  utmKeys.forEach((key) => {
    const value = params.get(key);

    if (value) {
       sessionStorage.setItem(key, value);

    }
  });

}, [location.search]);

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      {/* Header */}
  <header className={`es-header ${scrolled ? "scrolled" : ""}`}>
  
  {/* Logo (center on mobile, left on desktop) */}
 <img
  src="/LOGOESMAAASHBlack1.webp"
  alt="Logo"
  className="es-header-logo"
/>



  {/* Centered Navigation */}
  <nav className="nav-es">
    <NavLink to="/" end className={({ isActive }) => (isActive ? "active" : "")}>
      Home
    </NavLink>

    <NavLink to="/Events" className={({ isActive }) => (isActive ? "active" : "")}>
      Events
    </NavLink>
    
     <NavLink to="/Screening" className={({ isActive }) => (isActive ? "active" : "")}>
      Screening
    </NavLink> 

    <NavLink to="/Ambassadorclub" className={({ isActive }) => (isActive ? "active" : "")}>
      Ambassador Club
    </NavLink>
  </nav>

</header>




      {/* Body content with padding to avoid header overlap */}
      <div className="pt-24">
  <Suspense fallback={<div className="text-center py-10">Loading...</div>}>
    <Routes>

          <Route path="/" element={<Home />} />
          <Route path="/Events" element={<Events />} />
          <Route path="/Screening" element={<Screening />} />
          <Route path="/Ambassadorclub" element={<Ambassadorclub />} />
          <Route path="/SlamFestInfo" element={<SlamFestInfo />} />
          <Route path="/eventswithschools" element={<EventsWithSchools />} />
          
            <Route
  path="/events/Smaaash-Chess-Master-Mumbai-2nd-Edition"
  element={<Navigate to="/register/97" replace />}
/>


  {/* OLD registration URL support */}
  <Route path="/register/:id" element={<EventRegistration />} />

<Route path="/events/:slug" element={<EventRegistration />} />
          <Route
            path="/AmbassadorClubRegister"
            element={<AmbassadorClubRegister />}
          />
          <Route path="/event/:slug" element={<EventDetails />} />
          <Route path="/booking-success" element={<BookingSuccess />} />
          <Route path="/CookiesPolicy" element={<CookiesPolicy />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/RefundPolicy" element={<RefundPolicy />} />
          <Route path="/TermsConditions" element={<TermsConditions />} />

        {/* ✅ Redirect for promoted link */}
       

           </Routes>
  </Suspense>
</div>


      {/* Footer */}
      <Footer />
    </div>
  );
}
